export const translateStatus = (status: string) => {
  switch (status) {
    case 'Active':
      return 'Ativa'
    case 'Cancel':
      return 'Cancelada'
    case 'Declined':
      return 'Não aceite'
    case 'Lapsed':
      return 'Expirada'
    case 'LapsedQT':
      return 'Expirada'
    case 'Prospect':
      return 'Em vigor'
    case 'Quoted':
      return 'Em vigor'
    case 'NotPaid':
      return 'Por liquidar'
    case 'PENDING ':
      return 'Pendente'
    case 'APPROVED':
      return 'Aprovada'
    default:
      return status // Return the original status if no translation is found
  }
}

export const translateClaimsStatus = (status: string) => {
  switch (status) {
    case 'Active':
      return 'Ativa'
    case 'Cancel':
      return 'Cancelada'
    case 'CANCEL  ':
      return 'Declinado'
    case 'Declined':
      return 'Não aceite'
    case 'Lapsed':
      return 'Expirada'
    case 'LapsedQT':
      return 'Expirada'
    case 'Prospect':
      return 'Em vigor'
    case 'Quoted':
      return 'Em vigor'
    case 'NotPaid':
      return 'Por liquidar'
    case 'PENDING ':
      return 'Pendente'
    case 'APPROVED':
      return 'Aceite'
    default:
      return status // Return the original status if no translation is found
  }
}
